import { render, staticRenderFns } from "./biz-info-input.vue?vue&type=template&id=34c5e499&scoped=true&"
import script from "./biz-info-input.vue?vue&type=script&lang=js&"
export * from "./biz-info-input.vue?vue&type=script&lang=js&"
import style0 from "./biz-info-input.vue?vue&type=style&index=0&id=34c5e499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5e499",
  null
  
)

export default component.exports